<template>
  <main
    key="dashboard-layout"
    class="layout dashboard"
    :class="{ 'sidebar-collapsed': sidebarCollapsed }"
  >
    <LayoutSidebar @logout="logout" />
    <div class="content-view pl-3 pr-6 pt-4 pb-4">
      <LayoutSiteNav
        :show-breadcrumbs="$vuetify.display.mdAndUp"
        @toggle-menu="sidebarTempOpen = true"
      />
      <slot name="content-wrapper">
        <div class="relative z-[1] w-full">
          <slot name="default" />
        </div>
      </slot>
    </div>
    <OnboardingTour v-model:open="showTour" />
  </main>
</template>

<script setup lang="ts">
import { useSidebarStore } from "~/stores/sidebar";
import { PlatformTourProviderDisplayContext } from "~/types/symbols";

const { theme } = useTheme();
const { logout } = useAuth();
const { collapsed: sidebarCollapsed, tempOpen: sidebarTempOpen } =
  useSidebarStore();

const showTour = ref(false);
provide(PlatformTourProviderDisplayContext, {
  show: readonly(showTour),
  setShow(show) {
    showTour.value = show;
  },
});
</script>

<style scoped lang="scss">
@reference "#tailwind.css";
.layout.dashboard {
  @apply flex gap-3 flex-nowrap w-full h-dvh max-h-dvh max-w-[100vw];

  .content-view {
    @apply relative flex flex-col gap-6 grow max-h-full;
    margin-left: 236px; // sidebar (224px) + left offset (12px)
    max-width: calc(100% - 236px);
    padding-top: 6rem !important;

    @media (max-width: 767px) {
      margin-left: 0;
      max-width: 100vw;
      padding-top: 1rem !important;
    }
  }

  @media (min-width: 768px) {
    &.sidebar-collapsed .content-view {
      margin-left: 84px; // collapsed sidebar (72px) + left offset (12px)
      max-width: calc(100% - 84px);
    }
  }

  :deep(.page) {
    @apply w-full bg-surface py-4 px-4 md:py-6 md:px-6 rounded-2xl;
    box-shadow: 0px 10px 25px var(--app-gray-401-alpha-4);
  }
}
</style>

<style>
.v-application__wrap {
  align-items: center;
}
</style>
